import React from 'react';
import {View, ViewStyle} from 'react-native';

import {getSkeletonColors} from '../constants';

export const BoneDivider: React.FC<{style?: ViewStyle}> = React.memo(({style}) => (
  <View
    style={[{height: 1, backgroundColor: getSkeletonColors().border}, style]}
    accessibilityElementsHidden
    importantForAccessibility="no-hide-descendants"
  />
));

BoneDivider.displayName = 'BoneDivider';
